import AllRoutes from './routes'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { QueryClient, QueryClientProvider, QueryKey } from '@tanstack/react-query'
import { defaultQueryFn } from 'utils/api'
import { registerSafeAreaElement } from '@aashu-dubey/capacitor-statusbar-safe-area'
import { useEffect } from 'react'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import ZohoSalesIQWidget from 'scripts/Zoho'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { ORDER_FLOW_KEY } from 'app-constants'
import { App as AppPlugin } from '@capacitor/app'
import { StatusBar, Style } from '@capacitor/status-bar'

registerSafeAreaElement()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      cacheTime: 100 * 60 * 60, //1hour
    },
  },
})

function App() {
  useEffect(() => {
    async function performActiononPush() {
      const permStatus = await PushNotifications.checkPermissions()

      if (permStatus.receive === 'denied') {
        return
      }
      await PushNotifications.register()

      await PushNotifications.addListener(
        'pushNotificationActionPerformed',
        async (notification) => {
          const isPusher = import.meta.env.VITE_PUSH_SERVICE === 'pusher'
          const data = isPusher
            ? notification?.notification?.data?.data
            : notification?.notification?.data

          const targetType = data?.target_type
          const targetId = data?.target_id

          if (targetType === 'order') {
            window.location.href = `/easy-med/ongoing/${targetId}`
          } else if (targetType === 'order-requests') {
            window.location.href = `/easy-med/cart/${targetId}`
          }
        }
      )
      // AppPlugin.addListener('appStateChange', async () => {

      // })
    }

    if (Capacitor.isNativePlatform()) {
      StatusBar.setStyle({ style: Style.Dark })
      performActiononPush()
    }
    return () => {
      PushNotifications.removeAllListeners()
      AppPlugin.removeAllListeners()
    }
  }, [])

  const persister = createSyncStoragePersister({
    storage: window.sessionStorage,
    key: 'EAZYMED_CACHE',
  })

  return (
    <>
      <ZohoSalesIQWidget shouldLoadScript={!Capacitor.isNativePlatform()} />
      <div aria-live="polite" role="status" className="sr-only" id="a11y-live-region"> </div>
      <div
        className="fixed top-0 left-0 right-0 w-full bg-brand-700 z-[9999]"
        style={{
          '--safe-area-top': 'env(safe-area-inset-top)',
          paddingTop: 'var(--safe-area-top, 1.5rem)',
        } as React.CSSProperties}
      />
      <safe-area mode="margin" edges="top , bottom">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
              persister,
              dehydrateOptions: {
                shouldDehydrateQuery: (query: { queryKey: QueryKey }) => {
                  // Add condition to persist only orderFlowData
                  return [ORDER_FLOW_KEY].includes(query.queryKey[0] as string)
                },
              },
            }}
          >
            <QueryClientProvider client={queryClient}>
              <AllRoutes />
            </QueryClientProvider>
          </PersistQueryClientProvider>
        </LocalizationProvider>
      </safe-area>
    </>
  )
}

export default App
